import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import React, { FC, ReactNode } from 'react';
import Scrollbars from 'react-custom-scrollbars';

/* SideCard AutoScreen Fit for Desktop */

interface IDashboardContentAutoFit {
  children: ReactNode;
  config: {
    documentNavigationHeaderHeight: number;
    sectionOffsetA?: number;
    sectionOffsetB?: number;
    sectionOffsetC?: number;
    customOffset?: number;
    contentItemHeight: number;
  };
}

export const DashboardSideCardContentAutoFit: FC<IDashboardContentAutoFit> = (
  props
) => {
  const { viewPortHeight, isResolutionMobile } = useDeviceDetect();
  const calculateListScrollHeight = () => {
    if (props.config) {
      const calcu =
        (props.config.sectionOffsetA || 0) +
        (props.config.sectionOffsetB || 0) +
        (props.config.sectionOffsetC || 0) +
        (props.config.documentNavigationHeaderHeight || 0) +
        (props.config.customOffset || 0);
      const ROW_COUNT_LIMIT = Math.floor(
        (viewPortHeight - calcu) / props.config.contentItemHeight
      );
      /* 
      if (props.config.countListItemTreshold <= ROW_COUNT_LIMIT) {
        return '100%';
      } */
      const desktopHeight = ROW_COUNT_LIMIT * props.config.contentItemHeight;
      return desktopHeight;
    }
  };

  return (
    <Scrollbars
      hideTracksWhenNotNeeded={true}
      autoHeightMax={isResolutionMobile ? '100%' : calculateListScrollHeight()}
      autoHeight
      autoHide={false}
      autoHideTimeout={500}
      autoHideDuration={200}
    >
      <div
        style={{
          paddingLeft: '1px',
          paddingRight: '1px',
        }}
      >
        {props.children}
      </div>
    </Scrollbars>
  );
};

export default DashboardSideCardContentAutoFit;
